import React from 'react'

import { useSelector } from 'react-redux'

import { Detail } from 'routes/Menu/components/Detail'
import { useRecipeDetailData } from 'routes/Menu/components/Detail/hooks/useRecipeDetailData'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketDate, getNumPortions } from 'selectors/basket'

import { useMenuExperienceRecipeDetails } from './menuExperienceRecipeDetailContext'

type MenuExperienceRecipeDetailOverlayProps = {
  collectionId?: string
}

export const MenuExperienceRecipeDetailOverlay = ({
  collectionId,
}: MenuExperienceRecipeDetailOverlayProps) => {
  const { menuId, menuUrn, recipeDetail, closeRecipeDetail, selectRecipe, updateRecipePortions } =
    useMenuExperienceRecipeDetails()
  const deliveryDate = useSelector(getBasketDate)
  const boxNumPortions = useSelector(getNumPortions)
  const { getNumPortionsForRecipeId } = useBasket()
  const numPortions = recipeDetail
    ? getNumPortionsForRecipeId(recipeDetail.recipeId)
    : boxNumPortions

  const { loading, recipe, error, reload } = useRecipeDetailData({
    menuId,
    menuUrn,
    recipeUuid: recipeDetail?.recipeId ?? null,
    recipeUrn: recipeDetail?.recipeUrn,
    numPortions,
    deliveryDate,
    collectionId,
  })

  if (!recipeDetail) {
    return null
  }

  return (
    <Detail
      uuid={recipeDetail.recipeId}
      title={recipe?.title ?? recipeDetail.title}
      showOverlay
      loading={loading}
      error={error}
      recipe={recipe}
      reload={reload}
      position={recipeDetail.position}
      onClose={closeRecipeDetail}
      onSelectRecipe={selectRecipe}
      onRecipeDetailsClose={closeRecipeDetail}
      numPortions={numPortions}
      onUpdatePortions={(updatedNumPortions) => {
        void updateRecipePortions(recipeDetail.recipeId, updatedNumPortions)
        recipeDetail.onRecipePortionsUpdated?.(recipeDetail.recipeId, updatedNumPortions)
      }}
      initialFlexPortionEditorOpen={recipeDetail.initialFlexPortionEditorOpen}
      flexPortionContext={{
        deliveryDate,
        menuId,
        menuUrn,
        recipeId: recipeDetail.recipeId,
        recipeUrn: recipeDetail.recipeUrn,
      }}
    />
  )
}
